<!-- <div class="Loading"  *ngIf="isShowLoading==true">
        
    <img id="" src="assets/img/762.gif"   />
</div> -->

<div class="Loading"  *ngIf="isShowLoading==true">
    <div class="loader"></div> 
    <!-- <img id="" src="assets/img/762.gif"   /> -->
    <label class="loaderlabel">Please wait while Processing....</label>
</div>

<nav class="navbar  navbar-default navbar-fixed-top" id="top">
    <div class="container-fluid">
           
        <ul class="nav navbar-nav navbar-right">
            <li class="langDisable"><a (click)="changeLanguage('ar')" *ngIf="isEnglish">عربي</a></li>
            <li class="langDisable"><a (click)="changeLanguage('en')" *ngIf="!isEnglish">English</a></li>
        </ul>
    </div>
</nav>
<nav class="navbar navbar-default snav">
    <div class="container-fluid">
        <div class="navbar-header" id="navhead">
            <a class="navbar-brand" href="#">
                <img src="assets\theme\en\images\logo.png" width="170px"></a>
        </div>
    </div>
</nav>

<div class="LoginSection">


    <div class="row">
        <div class="col-lg-3 col-md-3 hidden-xs hidden-sm">


        </div>

        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="Motor">

                <div class="row">


                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

                        <div class="InsuredInformation Infomation">
                            <div class="Headertitle">
                                <span id="InsuredInfo">{{'Reset Password'|translate}}</span>

                            </div>

                            <div class="FormSection RegFormView">

                               
 <form #updatePasswordForm="ngForm">
    <div class="row">
        <div class="Msg">
            <div class="Clears"></div>
            <span class="Horizontal"></span>
        </div>
    </div>

    <div class="Login">
        <div class="row">
            <div class="Field">
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <label class="iqno">{{'Enter New Password'| translate}}</label>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
                        <input type="password" required id="txtPasswordEnter" name="txtPasswordEnter"
                        [(ngModel)]="NewPasswordEntered" class="form-control"
                        #txtPasswordEnter="ngModel" maxlength="20" autocomplete="off"
                        pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$">
                        <div *ngIf="txtPasswordEnter.errors && (txtPasswordEnter.dirty || txtPasswordEnter.touched)" class="text-danger valid">
                            <p *ngIf="txtPasswordEnter.errors.pattern">{{'Password must contains Alphanumeric, uppercase, lowercase and special characters and minimum length is 8 digits' | translate}}</p>
                            <p *ngIf="txtPasswordEnter.errors.required">{{'New Password is required' | translate}}</p>
                        </div>

                    </div>
                </div>
            </div>


            <div class="Field">
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <label class="otps">{{'Confirm Password'|translate}}</label>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
                        <input type="password"required id="txtRePassword" name="txtRePassword"
                        [(ngModel)]="NewPasswordReEntered" class="form-control"
                        #txtRePassword="ngModel" maxlength="20" autocomplete="off" (ngModelChange)="CheckPasswords(NewPasswordReEntered)">
                        <span class="text-danger valid" *ngIf="PasswordsValidate">{{'Both Passwords Must be same'}}</span>


                    </div>
                </div>
            </div>



            <div class="Clears"></div>


            <div class="buttonactions row">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                    <button type="button" class="btn btn-primary proceed" [disabled]="!updatePasswordForm.valid || PasswordsValidate" (click)="UpdatePassword()">{{
                        'Submit' | translate }}</button>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                    <button type="button" class="btn btn-primary cancel" (click)="CancelReset()">{{
                        'Cancel' | translate }}</button>
                </div>

            </div>


        </div>

    </div>
</form>




                            </div>
                            <div class="Footertitle">
                                <!-- <span id="InsuredInfo">{{'Create New Password'|translate}}</span> -->

                            </div>



                        </div>
                    </div>





                </div>






            </div>
        </div>

        <div class="col-lg-3 col-md-3 hidden-xs hidden-sm">


        </div>


    </div>
</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/PasswordReset/PasswordReset.html